export default "__VITE_ASSET__690cd4c5__"